var map = {
	"./AlbumOfTheMonth.jpg": "2486",
	"./AlbumReview.jpg": "db64",
	"./FeedCarrousel.jpg": "6bad",
	"./Giveaway.jpg": "06d9",
	"./NewsArticle.jpg": "0975",
	"./Osmium.jpg": "90fc",
	"./Poll.jpg": "787e",
	"./Quiz.jpg": "d6a2",
	"./SpotifyPlaylist.jpg": "4daf",
	"./ZMCafe.jpg": "9a3e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a33";